(function() {
    angular.module('NaviaqWebApp').constant('appVersion','25.07.04.1122');
})();
